module.exports = __webpack_public_path__ + "static/media/sri.4f836b47.svg";